import type { TOC } from '@ember/component/template-only';
import PageError from '../../components/page-error.gts';

interface Signature {
  Args: {};
}

const ItemShowError: TOC<Signature> = <template>
  <PageError
    @title="Failed to load item"
    @backRoute="items"
    @backLabel="My items"
  />
</template>;

export default ItemShowError;
